/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateExecuteRequest {
    getFixupPrototypeFunction() { return TemplateExecuteRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateExecuteRequest>): TemplateExecuteRequest {
        let obj = Object.assign(new TemplateExecuteRequest(), model);
        TemplateExecuteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateExecuteRequest>): TemplateExecuteRequest {
        if (!model) return null;
        return TemplateExecuteRequest.newInstance(<TemplateExecuteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateExecuteRequest) {
        if (!obj) return;

        models.TemplateExecuteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateExecuteRequest): boolean {
        Object.setPrototypeOf(obj, TemplateExecuteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.incident_reference) {
            models.TemplateIncidentReference.fixupPrototype(this.incident_reference);
        }
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.CloudAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Arguments to the template
     */
    args: any;

    /**
     * Cloud account details to execute the template
     */
    cloud_accounts: Array<models.CloudAccount>;

    /**
     * Incident reference.
     */
    incident_reference: models.TemplateIncidentReference;

}
